import { render, staticRenderFns } from "./custom_notifications_modal.vue?vue&type=template&id=fbe58658"
import script from "./custom_notifications_modal.vue?vue&type=script&lang=js"
export * from "./custom_notifications_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports